import { CoreInitiativesTasksName } from './name';
import { postInitiativeTask } from '@api';
import { updateInitiativeReferences } from '../_idMap/actions';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesTasksPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.INITIATIVE_TASK_CREATED, (action) => ({
				initiativeId: action.data.initiativeId
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						tasks: {
							toAdd: {
								assignedTo: request.assignedTo,
								completed: request.completed,
								initiativeId: request.initiativeId,
								initiativeTaskId: response.initiativeTaskId,
								name: request.name,
								orderIndex: request.orderIndex,
								sonarObjects: []
							}
						}
					}
				])
		]
	},
	name: CoreInitiativesTasksName,
	receive: true,
	request: true,
	requestHandler: postInitiativeTask
});
